export const locales: Record<string, () => Promise<any>> = {
	cs: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-cs" */ './cs'),
	da: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-da" */ './da'),
	de: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-de" */ './de'),
	en_GB: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-en-GB" */ './en_GB'
		),
	en_ZZ: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-en-ZZ" */ './en_ZZ'
		),
	en: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-en" */ './en'),
	es: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-es" */ './es'),
	fi: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-fi" */ './fi'),
	fr: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-fr" */ './fr'),
	hr: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-hr" */ './hr'),
	hu: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-hu" */ './hu'),
	it: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-it" */ './it'),
	ja: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-ja" */ './ja'),
	ko: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-ko" */ './ko'),
	nb: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-nb" */ './nb'),
	nl: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-nl" */ './nl'),
	pl: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-pl" */ './pl'),
	pt_BR: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-pt-BR" */ './pt_BR'
		),
	ru: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-ru" */ './ru'),
	sl: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-sl" */ './sl'),
	sr_RS: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-sr-RS" */ './sr_RS'
		),
	sr_YR: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-sr-YR" */ './sr_YR'
		),
	sv: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-sv" */ './sv'),
	th: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-th" */ './th'),
	tr: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-tr" */ './tr'),
	uk: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-uk" */ './uk'),
	vi: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-vi" */ './vi'),
	zh_TW: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-zh-tw" */ './zh_TW'
		),
	zh: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/edition-benefits-modal-i18n-zh" */ './zh'),
};

